<template>
  <b-card class="content-header">
    <div class="content-header-right d-flex align-items-center">
      <!-- Translation Statistics -->
      <div class="translation-stats mr-3">
        <div class="d-flex align-items-center">
          <b-badge v-if="missingTranslations > 0" variant="danger" class="mr-2">
            {{ missingTranslations }} brakujących
          </b-badge>
          <b-badge v-else variant="success" class="mr-2"> Kompletne </b-badge>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'TranslationsHeader',
  props: {
    title: {
      type: String,
      default: 'Zarządzanie tłumaczeniami',
    },
    subtitle: {
      type: String,
      default: 'Edytuj i zarządzaj tłumaczeniami systemu',
    },
    localeOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalTranslations: {
      type: Number,
      default: 0,
    },
    missingTranslations: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    'locale-changed',
    'export-translations',
    'show-import-modal',
    'show-create-locale-modal',
    'refresh-translations',
    'toggle-incomplete-filter',
  ],
};
</script>

<style lang="scss" scoped>
.content-header {
  margin-bottom: 2rem;
}

.rotate {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .content-header-right {
    margin-top: 1rem;
  }
}
</style>
